import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './helpers';
import { ResponseComponent } from './response/response.component';
const routes: Routes = [
    { path: '', redirectTo: 'loans', pathMatch: 'full' },
    { path: 'response', component: ResponseComponent },
    { path: '', loadChildren: () => import('./insystem/insystem.module').then(m => m.InsystemModule) },
    { path: 'sessions', loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule) },
    { path: 'forms', loadChildren: () => import('./forms_accounts/forms_accounts.module').then(m => m.FormsAccountsModule) }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
